import { useEffect, useState } from 'react';
import { Col, Form, Input, message, Modal, Row } from 'antd';
import { useAppDispatch } from '../../../store/hooks/hooks';
import './GeometryEditModal.less';
import { Geometry, PointColors } from '../../../models/Geometries';
import TextArea from 'antd/lib/input/TextArea';
import { BlockPicker } from 'react-color';
import { editGeometry } from '../../../store/slice/mapSlice';

interface Props {
  isModalVisible: boolean;
  geometry: Geometry;
  closeModal: () => void;
}

function GeometryEditModal({ isModalVisible, geometry, closeModal }: Props) {
  const [visible, setVisible] = useState(isModalVisible);
  const dispatch = useAppDispatch();
  const [form] = Form.useForm();
  const [showColorPicker, setShowColorPicker] = useState(false);
  const [color, setColor] = useState('');
  const title = geometry.tipo === 'punto' ? 'Atributos del Punto' : geometry.tipo === 'linea' ? 'Atributos de la Línea' : 'Atributos del Polígono'
  const colorLabel = geometry.tipo === 'punto' ? 'Elige un color para el punto' :
    geometry.tipo === 'linea' ? 'Elige un color para la línea' : 'Elige un color para el polígono'
  const handleOk = () => {
    form
      .validateFields()
      .then(async (values) => {
        await dispatch(editGeometry({
          title: values.title,
          description: values.description,
          color: color
        })).unwrap();
        form.resetFields();
        message.success({ content: 'Cambios guardados con éxito.', className: 'map-success-message' })
        closeModal()
      })
      .catch((info) => {
        console.log('Validate Failed:', info);
      });
  };

  const handleCancel = () => {
    closeModal();
  };

  useEffect(() => {
    setVisible(isModalVisible)
    form.resetFields();
    setColor(geometry.color);
  }, [isModalVisible]);


  return (
    <div>
      <Row>
        <Col span={24}>
          <Modal
            title={title}
            visible={visible}
            onOk={handleOk}
            onCancel={handleCancel}
            okText={'Guardar'}
            cancelText={'Cancelar'}
            className={'org-geometry-edit-modal'}
          >
            <Form className='org-geometry-edit-modal__form' layout={'vertical'} form={form} name='pointForm'>
              <Form.Item
                name={'title'}
                label={'Título:'}
                required={true}
                initialValue={geometry.titulo}
                rules={[
                  {
                    required: true,
                    message: 'Por favor ingresa un título.',
                  },
                ]}
              >
                <Input
                  required
                  placeholder={'Ingresa un título para el Punto.'}
                />
              </Form.Item>
              <Form.Item
                className={'org-geometry-edit-modal__color-form-item'}
                name={'color'}
                initialValue={color}
                label={colorLabel}
                required={true}
              >
                <button className={'org-geometry-edit-modal__color-picker-button'}
                        style={{ backgroundColor: color }}
                        type={'button'}
                        aria-label={'Elegir color'}
                        onClick={() => setShowColorPicker(!showColorPicker)}
                >

                </button>
                {showColorPicker ? (
                  <div className={'org-geometry-edit-modal__colorpicker-container'}>
                    <BlockPicker color={color} onChangeComplete={e => {
                      setColor(e.hex)
                      setShowColorPicker(!PointColors.includes(e.hex.toUpperCase()))
                    }} colors={PointColors} className='org-geometry-edit-modal__colorpicker' />
                  </div>
                ) : null}
              </Form.Item>
              <Form.Item
                name={'description'}
                label={'Descripción:'}
                style={{ marginBottom: 0 }}
                required={true}
                initialValue={geometry.descripcion}
                rules={[
                  {
                    required: true,
                    message: 'Por favor ingresa una descripción.',
                  },
                ]}
              >
                <TextArea required
                          placeholder={'Ingresa una descripción para el Punto.'}
                          rows={4}
                />

              </Form.Item>
            </Form>
          </Modal>
        </Col>
      </Row>
    </div>
  );
}

export default GeometryEditModal;
